import { Stack, Title, Text, Card, Button } from '@mantine/core';
import { IconPlus } from '@tabler/icons-react';

interface Props {
  title: string;
  description: string;
  newLabel?: string;
}

/**
 * Placeholder para páginas CRUD en desarrollo.
 * Reemplazar por la implementación específica cuando esté lista.
 */
export function PlaceholderPage({ title, description, newLabel }: Props) {
  return (
    <Stack gap="md">
      <Title order={2}>{title}</Title>
      <Card withBorder p="lg">
        <Text c="dimmed" mb="md">{description}</Text>
        {newLabel && <Button leftSection={<IconPlus size={16} />}>{newLabel}</Button>}
        <Text size="xs" c="dimmed" mt="lg">
          Esta pantalla está pendiente de implementar. El modelo de datos y las APIs del backend ya están definidas.
        </Text>
      </Card>
    </Stack>
  );
}
